export default __webpack_public_path__ + "static/media/AlertLargeFail.05b75f3e.svg";